import { STOP_CATEGORIES } from "../../data/stopCategories.js";
import { GameKeyboard } from "./GameKeyboard.jsx";

export function StopAnswerSheet({
  letter,
  answers,
  activeIndex,
  onActiveIndexChange,
  onType,
  onStop,
  canStop,
  progressLabel,
}) {
  return (
    <>
      <div className="stop-round-summary">
        <div
          className="stop-letter-reminder"
          aria-label={`Letra da rodada: ${letter}`}
        >
          <span>Letra da rodada</span>
          <strong>{letter}</strong>
        </div>
        {progressLabel && <span>{progressLabel}</span>}
      </div>
      <div className="stop-answer-list">
        {STOP_CATEGORIES.map((category, index) => {
          const selected = index === activeIndex;
          const answer = answers[category.id] || "";
          return (
            <button
              className={`stop-answer-row ${selected ? "selected" : ""}`}
              key={category.id}
              onClick={() => onActiveIndexChange(index)}
              type="button"
            >
              <span title={category.descricao || category.label}>
                {category.emoji} {category.label}
                {category.descricao && <small>{category.descricao}</small>}
              </span>
              <strong>
                {answer}
                {selected && <i className="stop-cursor">|</i>}
              </strong>
            </button>
          );
        })}
      </div>
      <button
        className={`btn ${canStop ? "btn-danger" : "btn-disabled"} stop-button`}
        disabled={!canStop}
        onClick={onStop}
        type="button"
      >
        🛑 PARAR!
      </button>
      <div className="stop-keyboard">
        <GameKeyboard aoDigitar={onType} estadoTeclas={{}} mostrarEspaco />
      </div>
    </>
  );
}
